import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { Button, Tooltip, OverlayTrigger } from 'react-bootstrap';

import {
  saveConfig,
  updateShowNavigator,
  updateLineChart,
  updateAvgChart,
  updateBlockersChart,
  updateMetrics,
  updateChartType,
  updateBreakdown
} from '../../FilterActions';

import zoomOnIcon from '../../../../assets/img/magnifier-on-01.svg';
import lineChartOnIcon from '../../../../assets/img/line-chart-icon-on.svg';
import lineChartAverageIcon from '../../../../assets/img/line-chart-avr-icon-on.svg';
import lineChartAverageSelectIcon from '../../../../assets/img/line-chart-avr-icon-off.svg';
import tableMetricsIcon from '../../../../assets/img/table-metrics.svg';
import breakdownOnIcon from '../../../../assets/img/breakdown-on.svg';
import chartScatterplotIcon from '../../../../assets/img/chart-scatterplot.svg';
import chartColumnsIcon from '../../../../assets/img/chart-columns.svg';
import blockersChartOnIcon from '../../../../assets/img/blockers-on.svg';

class Options extends Component {
  static defaultProps = {
    options: {}
  };

  constructor(props) {
    super(props);

    this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
  }

  handleCheckboxChange(e) {
    const { navigator, lineChart, avgChart, blockersChart, metrics, breakdown, chartType } = this.props;

    switch (e.currentTarget.name) {
      case 'switchChartType': {
        this.props.updateChartType(chartType === 'scatterplot' ? 'column' : 'scatterplot');
        break;
      }
      case 'showNavigator': {
        this.props.updateShowNavigator(!navigator);
        break;
      }
      case 'lineChart': {
        this.props.updateLineChart(!lineChart);
        break;
      }
      case 'avgChart': {
        this.props.updateAvgChart(!avgChart);
        break;
      }
      case 'blockersChart': {
        this.props.updateBlockersChart(!blockersChart);
        break;
      }
      case 'metrics': {
        this.props.updateMetrics(!metrics);
        break;
      }
      case 'breakdown': {
        this.props.updateBreakdown(!breakdown);
        break;
      }
    }
    this.props.saveConfig();
    setTimeout(() => window.dispatchEvent(new Event('resize')), 50);
  }

  render() {
    const {
      showNavigator,
      showLineChart,
      showAvgChart,
      showMetrics,
      showBlockers,
      blockersDisabled,
      switchChartType,
      chartType,
      navigator,
      lineChart,
      avgChart,
      blockersChart,
      metrics,
      showBreakdown,
      breakdown,
      options
    } = this.props;

    const tooltipZoom = (
      <Tooltip id="flowstats-tooltip" className="tooltip_white">
        {navigator ? 'Hide' : 'Show'} zoom control
      </Tooltip>
    );
    const tooltipLineChart = (
      <Tooltip id="flowstats-tooltip" className="tooltip_white">
        {lineChart ? 'Hide' : 'Show'} {options.lineChartTooltip ? options.lineChartTooltip : 'line chart'}
      </Tooltip>
    );
    const tooltipAverageChart = (
      <Tooltip id="flowstats-tooltip" className="tooltip_white">
        {avgChart ? 'Hide' : 'Show'} {options.avgChartTooltip ? options.avgChartTooltip : 'average line chart'}
      </Tooltip>
    );
    const tooltipTableMetrics = (
      <Tooltip id="flowstats-tooltip" className="tooltip_white">
        {metrics ? 'Hide' : 'Show'} process metrics
      </Tooltip>
    );
    const tooltipBreakdown = (
      <Tooltip id="flowstats-tooltip" className="tooltip_white">
        {breakdown ? 'Hide' : 'Show'} breakdown chart
      </Tooltip>
    );
    const tooltipChartType = (
      <Tooltip id="flowstats-tooltip" className="tooltip_white">
        Switch to {chartType === 'scatterplot' ? 'Histogram' : 'Scatterplot'}
      </Tooltip>
    );
    const tooltipBlockers = (
      <Tooltip id="blockers-tooltip" className="tooltip_white">
        {blockersDisabled ? 'Go to the Edit Dashboard page and select a blocked flag to enable this widget' : blockersChart ? 'Hide blockers' : 'Show blockers'}
      </Tooltip>
    );

    return (
      <div className="options" key="1">
        {switchChartType && (
          <OverlayTrigger placement="top" overlay={tooltipChartType}>
            <Button name="switchChartType" variant='light-secondary' size='md' className='btn-icon' onClick={this.handleCheckboxChange}>
              <img src={chartType === 'scatterplot' ? chartColumnsIcon : chartScatterplotIcon} className='switch-chart-type' alt="#" />
            </Button>
          </OverlayTrigger>
        )}
        {showMetrics && (
          <OverlayTrigger placement="top" overlay={tooltipTableMetrics}>
            <Button name="metrics" variant='light-secondary' size='md' className={`btn-icon ${metrics && 'selected'}`} onClick={this.handleCheckboxChange}>
              <img src={tableMetricsIcon} alt="#" />
            </Button>
          </OverlayTrigger>
        )}
        {showLineChart && (
          <OverlayTrigger placement="top" overlay={tooltipLineChart}>
            <Button name="lineChart" variant='light-secondary' size='md' className={`btn-icon ${lineChart && 'selected'}`} onClick={this.handleCheckboxChange}>
              <img src={lineChartOnIcon} alt="#" />
            </Button>
          </OverlayTrigger>
        )}
        {showAvgChart && (
          <OverlayTrigger placement="top" overlay={tooltipAverageChart}>
            <Button name="avgChart" variant='light-secondary' size='md' className={`btn-icon btn-no-filter ${avgChart && 'selected'}`} onClick={this.handleCheckboxChange}>
              <img src={avgChart ? lineChartAverageIcon : lineChartAverageSelectIcon} alt="#" />
            </Button>
          </OverlayTrigger>
        )}
        {showBreakdown && (
          <OverlayTrigger placement="top" overlay={tooltipBreakdown}>
            <Button name="breakdown" variant='light-secondary' size='md' className={`btn-icon ${breakdown && 'selected'}`} onClick={this.handleCheckboxChange}>
              <img src={breakdownOnIcon} alt="#" className='show-breakdown' />
            </Button>
          </OverlayTrigger>
        )}
        {showNavigator && (
          <OverlayTrigger placement="top" overlay={tooltipZoom}>
            <Button name="showNavigator" variant='light-secondary' size='md' className={`btn-icon ${navigator && 'selected'}`} onClick={this.handleCheckboxChange}>
              <img src={zoomOnIcon} className='show-navigator' alt="#" />
            </Button>
          </OverlayTrigger>
        )}
        {showBlockers && (
          <OverlayTrigger placement="top" overlay={tooltipBlockers}>
            <Button disabled={blockersDisabled} name="blockersChart" variant='light-secondary' size='md' className={`btn-icon ${blockersChart && 'selected'}`} onClick={this.handleCheckboxChange}>
              <img src={blockersChartOnIcon} alt="#" />
            </Button>
          </OverlayTrigger>
        )}
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    saveConfig: () => dispatch(saveConfig()),
    updateShowNavigator: enabled => dispatch(updateShowNavigator(enabled)),
    updateChartType: type => dispatch(updateChartType(type)),
    updateLineChart: enabled => dispatch(updateLineChart(enabled)),
    updateAvgChart: enabled => dispatch(updateAvgChart(enabled)),
    updateBlockersChart: enabled => dispatch(updateBlockersChart(enabled)),
    updateMetrics: enabled => dispatch(updateMetrics(enabled)),
    updateBreakdown: enabled => dispatch(updateBreakdown(enabled))
  };
};

const mapStateToProps = (state, ownProps) => {
  let chart = ownProps.chart || state.filters.chart;
  return {
    navigator: state.filters[chart].showNavigator,
    lineChart: state.filters[chart].lineChart,
    avgChart: state.filters[chart].avgChart,
    blockersChart: state.filters[chart].blockersChart,
    metrics: state.filters[chart].metrics,
    chartType: state.filters[chart].chartType,
    breakdown: state.filters[chart].breakdown
  };
};

const connected = connect(mapStateToProps, mapDispatchToProps)(Options);
export { connected as Options, Options as OptionsComponent };
